// extracted by mini-css-extract-plugin
export var aboveInput = "_ev-0";
export var actionButton = "_ev-5";
export var actionButtonContainer = "_ev-1";
export var actionIcon = "_ev-6";
export var aiInfoContainer = "_ev-2";
export var attachmentWrapper = "_ev-7";
export var bold = "_ev-3";
export var checkIcon = "_ev-8";
export var clickingRecipientBar = "_ev-11";
export var commentThreadSwitch = "_ev-a";
export var draftImage = "_ev-b";
export var draftImageContainer = "_ev-c";
export var draftImages = "_ev-e";
export var editButton = "_ev-g";
export var editor = "_ev-f";
export var editorContainer = "_ev-y";
export var editorErrorTooltipWrapper = "_ev-9";
export var headerDivider = "_ev-h";
export var icon = "_ev-i";
export var info = "_ev-j";
export var internal = "_ev-n";
export var internalDivider = "_ev-k";
export var internalMessage = "_ev-l";
export var messageInputCard = "_ev-m";
export var messageInputForm = "_ev-o";
export var messageInputFormInternal = "_ev-p";
export var options = "_ev-q";
export var publicMessageCustomer = "_ev-s";
export var publicMessageMerchant = "_ev-r";
export var removeImageButton = "_ev-d";
export var replyButtons = "_ev-t";
export var showSignatureButton = "_ev-u";
export var spinner = "_ev-v";
export var verticalButtonDivider = "_ev-4";
export var visibilitySelector = "_ev-w";
export var warning = "_ev-x";
export var wrappingText = "_ev-z";
export var writingInternalNoteTopBorder = "_ev-10";